const Features = () => {
  return (
    <div className="row stockwiz-landing__container__features">
      <div className="col-lg-3 col-6 mb-2">
        <div className="card-feature">
          <img src="/b2b/stockwiz/svg/engine.svg" alt="engine" />
          <div className="text">
            <span className="text-gradient">Lightning Fast</span>
            <br />
            <span className="text-white ">Trading Engine</span>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-6 mb-2">
        <div className="card-feature">
          <img src="/b2b/stockwiz/svg/newstrategy.svg" alt="newstrategy" />
          <div className="text">
            <span className="text-gradient">Premium Algo</span>
            <br />
            <span className="text-white">Strategies</span>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-6 mb-2">
        <div className="card-feature">
          <img src="/b2b/stockwiz/svg/newstrategy1.svg" alt="newstrategy1" />
          <div className="text">
            <span className="text-gradient">Build Your</span>
            <br />
            <span className="text-white">Strategies</span>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-6 mb-2">
        <div className="card-feature">
          <img src="/b2b/stockwiz/svg/football.svg" alt="football" />
          <div className="text">
            <span className="text-gradient">Live Trading</span>
            <br />
            <span className="text-white">Support</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
